export function getWorkTypeLocationString(
  workTypes: string[],
  location: string,
  t: (s: string) => string,
  includeHybrid: boolean = false,
) {
  const displayWorkTypes: Record<string, string> = {
    'remote': t('WORK_TYPE.REMOTE'),
  };
  if (includeHybrid) {
    displayWorkTypes['hybrid'] = t('WORK_TYPE.HYBRID');
  }

  const workTypeString = workTypes
    .filter((t) => Object.keys(displayWorkTypes).includes(t))
    .map((t) => displayWorkTypes[t])
    .join(', ');

  return [location, workTypeString].filter((s) => s.length > 0).join(', ');
}
